function main(param) {
	$(".menu span").unbind("click").on("click", function (e) {
		var isActive = $(this).hasClass("active");
		$(".menu span").not(this).removeClass("active");

		if (!isActive) {
			var thisClass = $(this).data("class");
			$("." + thisClass + " .billboard .arrow").click();
		}
	});

	$(".billboard .arrow").unbind("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		var self = this;
		var isActive = $(this).hasClass("active");
		var currentHeight = 

		$(".menu span").removeClass("active");
		$(".billboard .arrow.active").removeClass("active");
		$(".services .child.active").fadeOut();
		$(".module .arrow.active").removeClass("active");
		$(".module p.active").fadeOut();

		$("p.full.active").hide().removeClass("active");
		$("p.half.active").show().removeClass("active");
		$(".billboard").clearQueue().stop();
		$(".billboard.active").animate({height: "auto"}, 500);

		if (!isActive) {
			var thisClass = $(this).data("class");
			$(this).addClass("active");
			$(".menu span." + thisClass).addClass("active");

			$(this).closest(".billboard").animate({height: "auto"}, 250, function () {
				$(self).siblings("p.half").hide().addClass("active");
				$(self).siblings("p.full").show().addClass("active");

				if ($(".child." + thisClass).length)
					$(".child." + thisClass).fadeIn().addClass("active");
			}).addClass("active");

			setTimeout(function () {
				$('html, body').animate({
			      scrollTop: $(self).offset().top - 250
			    }, 375);
			}, 500);
		
		}
	});

	$(".module .arrow").unbind("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		var self = this;

		var isActive = $(this).hasClass("active");
		$(".module .arrow").removeClass("active");
		$(".module p").fadeOut();

		if (!isActive) {
			var thisClass = $(this).data("class");
			$(this).addClass("active");

			$(".module p." + thisClass).fadeIn().addClass("active");
		}

		setTimeout(function () {
			$('html, body').animate({
		      scrollTop: $(self).offset().top - 250
		    }, 375);
		}, 500);
	});

	if (param) {
		document.querySelector('span.'+ param+ '[data-class="' + param + '"]').click();
	}
}

export default function our_services(param) {
	main(param);
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/our_services.js
// module id = 14
// module chunks = 0